var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"136d586a2da06b5ef50a280a16c1c24bf685e55d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["webapp-frontend@mizar"]={id:"136d586a2da06b5ef50a280a16c1c24bf685e55d"};
      